import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import services from '../services';
import { PageHeader } from '../../../Common';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import _, { initial } from 'lodash';
import Paper from '@material-ui/core/Paper';
import { CommonDecryptParam } from '../../../../utils/CommonParams';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { LeafAmendment } from './LeafAmend';

const screenCode = 'TAGAMENDMENT';

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        fontSize: 10,

    },
    tabroot: {
        flexGrow: 1
    },
    title: {
        fontSize: 12,
    },
    pos: {
        marginBottom: 12,
    },
    btncolor: {
        background: '#10BA57'
    },
    btnroot: {
        backgroundColor: '#10BA57',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            backgroundColor: "#049C44"
        }
    },
    btnrootdel: {
        backgroundColor: '#FF0000',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            backgroundColor: " #e60000"
        }
    },
    colorscheme: {
        color: '#10BA57',
    },

    card: {
        alignContent: 'center'
    },

    label: {
        textTransform: 'capitalize',
    },
    rootpaper: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    autoComplete: {
        alignItems: 'center'
    }
}));

export function LeafAmendmentTagView(props) {
    const classes = useStyles();
    const [tagData, setTagData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [selectedRow, setSelectedRow] = useState();

    useEffect(() => {
        var id = CommonDecryptParam(props.match.params["id"]);
        GetTagWiseDetails(id);
    }, []);

    async function GetTagWiseDetails(id) {
        var result = await services.getTagWiseDetails(id);
        setTagData(result);
    }

    const handleClickOpen = (data) => {
        setVisible(true)
        setSelectedRow(data);
    };

    return (
        <Fragment>
            <Card id="top" className={classes.root} >
                <CardContent>
                    <PageHeader
                        title={"Edit Tag Details"}
                        isButtonEnable={true}
                        buttonText="Back to Listing"
                        path="/leafAmendV1"
                    />
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Tag No</TableCell>
                                    <TableCell align="center">CardNumber</TableCell>
                                    <TableCell align="center">CardRead Time</TableCell>
                                    <TableCell align="center">Route</TableCell>
                                    <TableCell align="center">Gross</TableCell>
                                    <TableCell align="center">Net</TableCell>
                                    <TableCell align="center">Actual</TableCell>
                                    <TableCell align="center">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tagData.map((row) => (
                                    <TableRow key={row.tagNumber}>
                                        <TableCell align="right" component="th" scope="row">
                                            {row.tagNumber}
                                        </TableCell>
                                        <TableCell component="th" scope="row" align="right"> {row.cardNumber}</TableCell>
                                        <TableCell component="th" scope="row" align="right"> {row.tagReadTime.split('T')[0]}</TableCell>
                                        <TableCell component="th" scope="row" align="right"> {row.routeName}</TableCell>
                                        <TableCell component="th" scope="row" align="right"> {row.grossAmount}</TableCell>
                                        <TableCell component="th" scope="row" align="right"> {row.netAmount}</TableCell>
                                        <TableCell component="th" scope="row" align="right"> {row.actualAmount}</TableCell>
                                        <TableCell align="center">
                                            <IconButton aria-label="delete" className={classes.margin} onClick={e => handleClickOpen(row)}>
                                                <EditIcon fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <br />
                    <br />
                    {visible ? <LeafAmendment datax={selectedRow} isHide={!visible} /> : null
                    }
                </CardContent>
            </Card>
        </Fragment>
    );

}